module.exports = __webpack_public_path__ + "img/Couch-Pillows-icon-WFH.39eaedf0.png";